import { WebsiteBlock, WebsitePageContent } from "../interfaces/WebsiteBlock";
import { extractNavbarFromHtml } from "./htmlImport.utils";

export const HTML_PAGE_BLOCK_TYPE = "html-page" as const;

export const isHtmlPageContent = (content?: WebsitePageContent | null) =>
  Boolean(
    content?.blocks?.some((block) => block.type === HTML_PAGE_BLOCK_TYPE) ||
      (content?.mode === "html" && content.html)
  );

export const createHtmlPageBlockContent = (html: string, brandName = "Mi Marca"): WebsitePageContent => {
  const { navbar, htmlWithoutNavbar } = extractNavbarFromHtml(html, brandName);

  return {
    blocks: [
      navbar,
      {
        id: `html-page-${Date.now()}`,
        type: HTML_PAGE_BLOCK_TYPE,
        html: htmlWithoutNavbar,
      },
    ],
  };
};

export const migrateHtmlModeContent = (content: WebsitePageContent): WebsitePageContent => {
  if (content.mode === "html" && content.html) {
    return createHtmlPageBlockContent(content.html);
  }
  return content;
};

export const migrateHtmlPageOnlyToHybrid = (
  content: WebsitePageContent,
  brandName = "Mi Marca"
): WebsitePageContent => {
  const blocks = content.blocks || [];
  const htmlBlock = blocks.find((block) => block.type === HTML_PAGE_BLOCK_TYPE);
  const hasNavbar = blocks.some((block) => block.type === "navbar");

  if (!htmlBlock || hasNavbar) return content;

  const { navbar, htmlWithoutNavbar } = extractNavbarFromHtml(htmlBlock.html || "", brandName);

  return {
    ...content,
    blocks: [
      navbar,
      ...blocks.map((block) =>
        block.type === HTML_PAGE_BLOCK_TYPE ? { ...block, html: htmlWithoutNavbar } : block
      ),
    ],
  };
};

export const hasHybridHtmlPage = (blocks: WebsiteBlock[] = []) =>
  blocks.some((block) => block.type === HTML_PAGE_BLOCK_TYPE) &&
  blocks.some((block) => block.type === "navbar");
